var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  ', '\n'], ['\n  display: flex;\n  ', '\n']);

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import * as React from 'react';
import styled from 'styled-components';
import createComponentFromTagProp from 'react-create-component-from-tag-prop';
import '../types';
import grid from '../mixins/grid';
import GridUnit from './GridUnit';
var GridComponent = createComponentFromTagProp({
  tag: 'div',
  prop: 'component',
  propsToOmit: ['halign', 'valign', 'reverse', 'wrap']
});
var Grid = styled(GridComponent)(_templateObject, grid);
export default Grid;